class BlockCTA {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.emailFormEl = this.blockEl.querySelector('.block-cta__email-form');

		if (this.emailFormEl) {
			this.emailFormEl.addEventListener('submit', this.emailFormSubmitHandler);
		}
	}

	emailFormSubmitHandler = (e) => {
		e.preventDefault();

		const formEl = e.currentTarget;

		if (!formEl) {
			return;
		}

		const inputEl = formEl.querySelector('input.input-with-icon__input');

		if (!inputEl) {
			return;
		}

		inputEl.disabled = true;
		formEl.classList.add('loading');

		setTimeout(() => {
			inputEl.disabled = false;
			formEl.classList.remove('loading');
		}, 2000);
	};
}

export default BlockCTA;
